import {createSlice} from '@reduxjs/toolkit'

const initialState = {
    hasSidebar: false,
    isOpenSidebar: false,
}


export const ScreenDesignerSlice = createSlice({
    name: 'screenDesigner',
    initialState,
    reducers: {
        insertSideBar: state => {
            state.hasSidebar = true;
            state.isOpenSidebar = true;
        },
        setSidebarState: (state, action) => {
            state.isOpenSidebar = action.payload;
        }
    }
});

export const {
    insertSideBar, setSidebarState
} = ScreenDesignerSlice.actions;

export default ScreenDesignerSlice.reducer;